
import CAMGreen from "./logo.svg";
import footerImage from "./footerImage.svg";

export const images = {
  NavLogoImage: CAMGreen,
  FooterImage: footerImage,
};
